import type { AxiosRequestConfig } from 'axios'

import type { TGetParametrosPropostaResponse } from '@/features/parametros/interfaces/parametros.types'
import { HttpService } from '@/shared/lib/http'

export class GetParametrosProposta extends HttpService {
  execute = async () => {
    return this.http.get<TGetParametrosPropostaResponse, AxiosRequestConfig>(`/api/v2/Parametros/proposta`)
  }
}
